import React, { useContext } from 'react';
import { Menu, Tooltip } from 'antd';
import * as Icons from '@ant-design/icons';
import { NavLink } from 'react-router-dom';

import { SidebarLogo, StyledSider } from '../styled';
import { useSidebar } from '../hooks';
import { MeContext } from '../../me/context/context';
import { CashRegisterStatusContext } from '../../cash-register/context/status';

export const AppSidebar = () => {
  const { isOpen, activeKey } = useSidebar();
  const { can, state } = useContext(MeContext);
  const cashRegisterStatus = useContext(CashRegisterStatusContext);
  console.log("process.env.REACT_APP_CLIENT_LOGO", process.env.REACT_APP_CLIENT_LOGO)
  return (
    <StyledSider trigger={null} collapsible={true} width={224} collapsedWidth={46} collapsed={!isOpen}>
      <SidebarLogo>
        {process.env.REACT_APP_CLIENT_LOGO ? <img src={process.env.REACT_APP_CLIENT_LOGO} alt='main_logo' /> : null}
      </SidebarLogo>
      <Menu theme='light' mode='inline' selectedKeys={[activeKey]}>
        <Menu.ItemGroup key='statistics' title='Ümumi'>
          {!state.user.data?.emergencyModeIsEnabled && (
            <Menu.Item key='/statistics' icon={<Icons.RocketOutlined />}>
              Piştaxta
              <NavLink to='/statistics' />
            </Menu.Item>
          )}
          {can(33) && (
            <Menu.Item key='/customers' icon={<Icons.TeamOutlined />}>
              Müştərilər
              <NavLink to='/customers' />
            </Menu.Item>
          )}
          {can(1) && (
            <Menu.Item key='/users' icon={<Icons.UserSwitchOutlined />}>
              İstifadəçilər
              <NavLink to='/users' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>
        <Menu.ItemGroup key='labaratory' title='Labaratoriya'>
          {can(121) && (
            <Menu.Item key='/analyzes' icon={<Icons.FileExcelOutlined />}>
              Analizlər
              <NavLink to='/analyzes' />
            </Menu.Item>
          )}
          {can(124) && (
            <Menu.Item key='/analyzes/templates' icon={<Icons.FileTextOutlined />}>
              Analiz Şablonları
              <NavLink to='/analyzes/templates' />
            </Menu.Item>
          )}
          {can(123) && (
            <Menu.Item key='/subjects' icon={<Icons.SubnodeOutlined />}>
              Predmetlər
              <NavLink to='/subjects' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key='appointments' title='Qəbul'>
          {can(66) && (
            <Menu.Item key='/appointments/create' icon={<Icons.TeamOutlined />}>
              Qəbula yazılmaq
              <NavLink to='/appointments/create' />
            </Menu.Item>
          )}
          {can(64) && (
            <Menu.Item key='/appointments' icon={<Icons.TableOutlined />}>
              Qəbul reyestr
              <NavLink to='/appointments' />
            </Menu.Item>
          )}
          {can(64) && (
            <Menu.Item key='/appointments/calendar' icon={<Icons.CalendarOutlined />}>
              Qəbul təqvimi
              <NavLink to='/appointments/calendar' />
            </Menu.Item>
          )}
          <Menu.Item key='/sms-logs' icon={<Icons.RedEnvelopeOutlined />}>
            SMS Arxivi
            <NavLink to='/sms-logs' />
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.ItemGroup key='cash_register' title='Kassa'>
          {can(77) && !cashRegisterStatus.data?.connected && (
            <Menu.Item disabled={true} key='/cash_register' icon={<Icons.MoneyCollectOutlined />}>
              <Tooltip title='Kassa əməliyyatları üçün ekranın yuxarı hissəsində olan "Obyekt seç" düyməsindən istifadə etməklə obyektinizi seçin'>
                Kassa aparatı
                <NavLink to='/cash_register' />
              </Tooltip>
            </Menu.Item>
          )}
          {can(77) && cashRegisterStatus.data?.connected && (
            <Menu.Item key='/cash_register' icon={<Icons.MoneyCollectOutlined />}>
              Kassa aparatı
              <NavLink to='/cash_register' />
            </Menu.Item>
          )}
          {can(94) && (
            <Menu.Item key='/cash_register/checks' icon={<Icons.FileExclamationOutlined />}>
              Çap edilmiş çeklər
              <NavLink to='/cash_register/checks' />
            </Menu.Item>
          )}
          {can(109) && !state.user.data?.emergencyModeIsEnabled && (
            <Menu.Item key='/cash-flow' icon={<Icons.FileExclamationOutlined />}>
              Cashflow
              <NavLink to='/cash-flow' />
            </Menu.Item>
          )}
          {can(28) && (
            <Menu.Item key='/transactions' icon={<Icons.TransactionOutlined />}>
              Tranzaksiyalar
              <NavLink to='/transactions' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>
        <Menu.ItemGroup key='warehouse' title='Anbar'>
          {can(38) && (
            <Menu.Item key='/products' icon={<Icons.OrderedListOutlined />}>
              Məhsul çeşidləri
              <NavLink to='/products' />
            </Menu.Item>
          )}
          {can(136) && (
            <Menu.Item key='/warehouse-products' icon={<Icons.ClusterOutlined />}>
              Anbardakı mallar
              <NavLink to='/warehouse-products' />
            </Menu.Item>
          )}
          {can(143) && (
            <Menu.Item key='/purchase-documents' icon={<Icons.DiffOutlined />}>
              Alış sənədləri
              <NavLink to='/purchase-documents' />
            </Menu.Item>
          )}
          {can(138) && (
            <Menu.Item key='/warehouse-transfers' icon={<Icons.BranchesOutlined />}>
              Təminatlar
              <NavLink to='/warehouse-transfers' />
            </Menu.Item>
          )}
          {can(140) && (
            <Menu.Item key='/consumptions' icon={<Icons.PushpinOutlined />}>
              Sərfiyyatlar
              <NavLink to='/consumptions' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>

        <Menu.ItemGroup key='catalogs' title='Kataloqlar'>
          {can(58) && (
            <Menu.Item key='/doctors' icon={<Icons.UsergroupAddOutlined />}>
              Həkimlər
              <NavLink to='/doctors' />
            </Menu.Item>
          )}
          {can(8) && (
            <Menu.Item key='/clinics' icon={<Icons.ClusterOutlined />}>
              Partnyor klinikalar
              <NavLink to='/clinics' />
            </Menu.Item>
          )}
          {can(48) && (
            <Menu.Item key='/services' icon={<Icons.SortAscendingOutlined />}>
              Xidmətlər
              <NavLink to='/services' />
            </Menu.Item>
          )}
          {can(133) && (
            <Menu.Item key='/insurances' icon={<Icons.ClusterOutlined />}>
              Sığorta şirkətləri
              <NavLink to='/insurances' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>
        <Menu.ItemGroup key='settings' title='Proqram ayarları'>
          {can(18) && (
            <Menu.Item key='/status' icon={<Icons.BuildOutlined />}>
              Statuslar
              <NavLink to='/status' />
            </Menu.Item>
          )}
          {can(13) && (
            <Menu.Item key='/models' icon={<Icons.AppstoreOutlined />}>
              Modellər
              <NavLink to='/models' />
            </Menu.Item>
          )}
          {can(28) && (
            <Menu.Item key='/groups' icon={<Icons.GroupOutlined />}>
              Qruplar
              <NavLink to='/groups' />
            </Menu.Item>
          )}
          {can(23) && (
            <Menu.Item key='/operations' icon={<Icons.SettingOutlined />}>
              Əməliyyatlar
              <NavLink to='/operations' />
            </Menu.Item>
          )}
          {can(122) && (
            <Menu.Item key='/device-logs' icon={<Icons.MergeCellsOutlined />}>
              Cihazdan gələnlər
              <NavLink to='/device-logs' />
            </Menu.Item>
          )}
        </Menu.ItemGroup>
      </Menu>
    </StyledSider>
  );
};
